var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgScbLoadingSpinner = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  fill: "currentColor"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  fill: "currentColor",
  stroke: "currentColor",
  r: 15,
  cx: 40,
  cy: 100
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  calcMode: "spline",
  dur: 2,
  values: "1;0;1;",
  keySplines: ".5 0 .5 1;.5 0 .5 1",
  repeatCount: "indefinite",
  begin: -0.4
}))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  fill: "currentColor",
  stroke: "currentColor",
  r: 15,
  cx: 100,
  cy: 100
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  calcMode: "spline",
  dur: 2,
  values: "1;0;1;",
  keySplines: ".5 0 .5 1;.5 0 .5 1",
  repeatCount: "indefinite",
  begin: -0.2
}))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  fill: "currentColor",
  stroke: "currentColor",
  r: 15,
  cx: 160,
  cy: 100
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  calcMode: "spline",
  dur: 2,
  values: "1;0;1;",
  keySplines: ".5 0 .5 1;.5 0 .5 1",
  repeatCount: "indefinite",
  begin: 0
}))));
export default SvgScbLoadingSpinner;